import { Box, createStyles, makeStyles, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_TEXT,
  DARKER_PROGRESS_OVERLAY_BACKGROUND_TRANSPARENT,
  OFFWHITE_PROGRESS_OVERLAY_BACKGROUND_TRANSPARENT,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_TEXT,
  WARNING_BUTTON_BACKGROUND,
  WARNING_TEXT,
  PLAIN_TEXT,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: '2.5em',
      '& > div:first-child': {
        maxWidth: 293,
        textAlign: 'center',
        width: '100%',

        [theme.breakpoints.down(960)]: {
          margin: '0 auto',
        },
      },
      '& > div:last-child': {
        width: '100%',
      },
      '& > div:last-child > div:first-child': {
        marginBottom: 20,
      },

      [theme.breakpoints.down(960)]: {
        flexDirection: 'column',
      },
    },
    imgContainer: {
      maxWidth: 293,
      minWidth: 293,
      height: 403,
      borderImageSlice: '1',
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      marginBottom: 20,
      position: 'relative',
    },
    img: {
      width: '92%',
      height: '94%',
      objectFit: 'cover',
      borderRadius: 5,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    yellow: {
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
    },
    primary: {
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
    },
    slashes: {
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
    },
    dataContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      marginBottom: 20,

      '& > div': {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    dataHeading: {
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
      marginBottom: 5,
    },
    btnContainer: {
      display: 'flex',
      gap: '1em',
      [theme.breakpoints.down(1200)]: {
        flexDirection: 'column',
      },
    },
    completeText: {
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
      marginBottom: 10,
      [theme.breakpoints.down(960)]: {
        flex: 1,
        textAlign: 'center',
      },
    },
    tooltipContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: 15,
    },
    primaryBtn: {
      height: 50,
      border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
      fontSize: 15,
      background: 'none',
    },
    secondaryBtn: {
      height: 50,
      border: `1px solid ${WARNING_BUTTON_BACKGROUND}`,
      fontSize: 15,
      background: 'none',
    },
    dashboard: {
      marginTop: 20,

      '& .MuiButtonBase-root': {
        height: 50,
        fontSize: 15,
      },
    },
    link: {
      textDecoration: 'none',
    },
    clearButton: {
      background: 'none',

      '&:hover': {
        background: 'none',
        opacity: 0.7,
      },
    },

    circle: {
      stroke: 'url(#linearColors)',
      position: 'absolute',
    },
  }),
);

export const ProgressOverlay = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.type === 'dark'
      ? DARKER_PROGRESS_OVERLAY_BACKGROUND_TRANSPARENT
      : OFFWHITE_PROGRESS_OVERLAY_BACKGROUND_TRANSPARENT,
  position: 'absolute',
  width: 'calc(100% - 10px)',
  height: 'calc(100% - 4px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
  margin: 2,
  borderRadius: 10,
}));
